import { Box } from "@mui/material"
import ManageWebApi from "api/application/manageWeb"
import { ArticleProps, ArticleSortProps } from "api/application/manageWeb-interface"
import { notiError, notiSuccess } from "component/notifications/notifications"
import CardDraggableList from "new-components/card/card-list"
import AlertModal from "new-components/modal/alert-modal"
import { useState } from "react"
import { useTranslation } from "react-i18next"


type ArticleListProps = {
    dataList: any
    onEdit: (status: boolean, item?: any) => void
    statusDel: boolean
    reLoad: () => void
}

const ArticleList = (props: ArticleListProps) => {
    const { t } = useTranslation()
    const t_ARTICLE = "MANAGE_WEB.ARTICLE"
    const [isDragging, setIsDragging] = useState<boolean>(false)
    const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
    const [id, setId] = useState(0)
    const [status, setStatus] = useState('')
    const [subject, setSubject] = useState('')

    const onDragStart = (result: any) => {
        setIsDragging(true)
    }

    const onDragEnd = async (result: any) => {
        if (!result.destination) {
            setIsDragging(false)
            return
        }
        const { source, destination } = result;
        const data = props?.dataList
        const [removed] = data.splice(source.index, 1);
        data.splice(destination.index, 0, removed);

        const newData: ArticleSortProps[] = data.map((item: any, index: number) => {
            return { articleId: item.articleId, sorting: index + 1 }
        })
        await ManageWebApi.sortArticle(newData).finally(() => {
            setIsDragging(false)
            props.reLoad()
        })
    }

    const onSaveStatus = async (status: 'ACTIVE' | 'INACTIVE', data: any) => {
        const id = data?.articleId || 0
        const newPayload: ArticleProps = { ...data, status: status }
        if (id !== 0) {
            const res = await ManageWebApi.updateArticle(id, newPayload)
            if (res === "pass") {
                setIsOpenAlertModal(false)
                notiSuccess(t(`${t_ARTICLE}.SAVE_STATUS`))
                props.reLoad()
            } else {
                setIsOpenAlertModal(false)
                notiError(t(`${t_ARTICLE}.SAVE_ERROR`))
            }
        } else {
            setIsOpenAlertModal(false)
            notiError(t(`${t_ARTICLE}.SAVE_ERROR`))
        }
    }

    const onDelete = () => {
        if (id !== 0) {
            ManageWebApi.delArticle(id).then((resp) => {
                if (resp === "pass") {
                    setIsOpenAlertModal(false)
                    notiSuccess(t(`MANAGE_WEB.ARTICLE.DEL_SUC`))
                    props.reLoad()
                } else {
                    setIsOpenAlertModal(false)
                    notiError(t(`MANAGE_WEB.ARTICLE.SAVE_ERROR`))
                }
            })
        } else {
            setIsOpenAlertModal(false)
            notiError(t(`MANAGE_WEB.ARTICLE.SAVE_ERROR`))
        }
    }

    return (
        <Box>
            <AlertModal
                isOpen={isOpenAlertModal}
                title={status !== '' ? t(t_ARTICLE + '.NOTI_CHANGE_STATUS') : t(`MANAGE_WEB.TITLE_DEL`)}
                message={status !== '' ? t(`${t_ARTICLE}.ALERT.CONFIRM_STATUS_`, {
                    subject: subject || '-',
                    status: t(`STATUS.${status}`)
                }) : t('MANAGE_WEB.ARTICLE.NOTI_DEL')}
                type={status !== '' ? 'warning' : 'error'}
                handleClose={() => setIsOpenAlertModal(false)}
                onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
                onSubmit={{
                    onClick: () => {
                        if (status !== '') {
                            const item = props.dataList.find((i: any) => i.articleId === id)
                            onSaveStatus(status as 'ACTIVE' | 'INACTIVE', item)
                        } else {
                            onDelete()
                        }
                    },
                    title: t('BUTTON.SUBMIT')
                }}
            />
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                maxHeight: 'calc(100vh - 35vh)',
                overflowY: 'auto',
            }}>
                <CardDraggableList
                    data={props.dataList}
                    isDragging={isDragging}
                    onDragEnd={onDragEnd}
                    onDragStart={onDragStart}
                    idField="articleId"
                    topicField="article"
                    onActive={(e) => {
                        setId(e.articleId)
                        setIsOpenAlertModal(true)
                        setStatus("ACTIVE")
                        setSubject(e.topic)
                    }
                    }
                    onInActive={(e) => {
                        setId(e.articleId)
                        setIsOpenAlertModal(true)
                        setStatus("INACTIVE")
                        setSubject(e.topic)
                    }
                    }
                    onEdit={(status, item) => props.onEdit(status, item)}
                    onDelete={(e) => {
                        setId(e.articleId)
                        setIsOpenAlertModal(true)
                    }}
                />
            </Box>
        </Box>
    )
}

export default ArticleList